import { render, staticRenderFns } from "./LanguageFormItem.vue?vue&type=template&id=2adc7e30&scoped=true"
import script from "./LanguageFormItem.vue?vue&type=script&lang=js"
export * from "./LanguageFormItem.vue?vue&type=script&lang=js"
import style0 from "./LanguageFormItem.vue?vue&type=style&index=0&id=2adc7e30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adc7e30",
  null
  
)

export default component.exports